const ua = navigator.userAgent.toLowerCase()
const jfmore = ua.match(/(ios|android)_jfmore_(\d\.\d\.\d)/i)

export default () => {
  return {
    ios: /(iphone|ipod|ipad|ios)/i.test(ua),
    android: !!ua.match(/android/i),
    weixin: !!ua.match(/micromessenger/i),
    jfmore: (jfmore && jfmore[2].trim()) || ''
  }
}
